import { render } from "./refugee_form.html?vue&type=template&id=489da504&external"
import script from "./refugee_form.js?vue&type=script&lang=js&external"
export * from "./refugee_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__